import React from 'react';
import { List, useTable, EditButton, DeleteButton, CreateButton } from '@refinedev/antd';
import { Table, Tag, Space } from 'antd';

export interface PetSkinCategoryRow {
  id: string;
  slug: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
}

/** The filter chips over the Store and My Collection. */
export const PetSkinCategoryList: React.FC = () => {
  const { tableProps } = useTable<PetSkinCategoryRow>({
    resource: 'pet-skin-categories',
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List title="Pet Skin Categories" headerButtons={<CreateButton />}>
      <Table {...tableProps} rowKey="id">
        <Table.Column title="Name" dataIndex="name" />
        <Table.Column
          title="Slug"
          dataIndex="slug"
          render={(slug: string) => <code>{slug}</code>}
        />
        <Table.Column title="Sort" dataIndex="sortOrder" width={70} />
        <Table.Column
          title="Active"
          dataIndex="isActive"
          width={90}
          render={(v: boolean) => <Tag color={v ? 'green' : 'default'}>{v ? 'Yes' : 'No'}</Tag>}
        />
        <Table.Column
          title="Actions"
          width={110}
          render={(_: unknown, row: PetSkinCategoryRow) => (
            <Space>
              <EditButton hideText size="small" recordItemId={row.id} />
              <DeleteButton hideText size="small" recordItemId={row.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
